import Wrapper from './wrapper';
import {
  IImportFieldsParams,
  IImportFieldsResponse,
  IQueryParam,
  IReportParams,
  ITrainingSetListResponse,
  ITrainingSetUpdateParams,
  IWrapper,
} from './types';
import { ITrainingSetCreate, ITrainingSet } from '../types/my-types';

class TrainingSet {
  wrapper: IWrapper;
  /**
   * @param {Wrapper} wrapper
   */
  constructor(wrapper: Wrapper) {
    this.wrapper = wrapper;
  }

  /**
   * Creates a new training set in your data pool
   * @param {Object} data
   * @returns {Promise}
   */
  create(data: ITrainingSetCreate) {
    return this.wrapper.client.post<ITrainingSet, ITrainingSet>(
      `data-pools/${this.wrapper.dataPoolId}/training-sets/?advanced=true`,
      data
    );
  }

  retrieve(id: string) {
    return this.wrapper.client.get<ITrainingSet, ITrainingSet>(
      `data-pools/${this.wrapper.dataPoolId}/training-sets/${id}/?advanced=true`
    );
  }

  update(id: string, data: ITrainingSetUpdateParams) {
    return this.wrapper.client.patch(
      `data-pools/${this.wrapper.dataPoolId}/training-sets/${id}/?advanced=true`,
      data
    );
  }

  list(params: IQueryParam) {
    return this.wrapper.client.get<ITrainingSetListResponse, ITrainingSetListResponse>(
      `data-pools/${this.wrapper.dataPoolId}/training-sets/`,
      { params }
    );
  }

  listPublic(dataPoolId: string, params: IQueryParam) {
    return this.wrapper.client.get<ITrainingSetListResponse, ITrainingSetListResponse>(
      `data-pools/${dataPoolId}/public-training-set-list/?advanced=true`,
      { params }
    );
  }

  del(id: string) {
    return this.wrapper.client.delete(
      `data-pools/${this.wrapper.dataPoolId}/training-sets/${id}/?advanced=true`
    );
  }

  importFields(params: IImportFieldsParams) {
    return this.wrapper.client.post<IImportFieldsResponse, IImportFieldsResponse>(
      `import-field-list/?advanced=true`,
      params
    );
  }

  requestTraining(id: string) {
    // https://api.glynt.ai/v6/docs/advanced/#request-training
    // TODO: check doc is incorrect, use post instead
    return this.wrapper.client.post<ITrainingSet, ITrainingSet>(
      `data-pools/${this.wrapper.dataPoolId}/training-sets/${id}/request-training/?advanced=true`
    );
  }

  fieldDistribution(id: string, params: IReportParams) {
    return this.wrapper.client.get(
      `data-pools/${this.wrapper.dataPoolId}/training-sets/${id}/field-distribution/`,
      { params }
    );
  }

  generatePages(id: string) {
    return this.wrapper.client.post(
      `data-pools/${this.wrapper.dataPoolId}/training-sets/${id}/pages/?advanced=true`
    );
  }

  refreshTokenizeds(id: string) {
    return this.wrapper.client.post(
      `data-pools/${this.wrapper.dataPoolId}/training-sets/${id}/refresh-tokenizeds/?advanced=true`
    );
  }

  resetValidationRules(id: string) {
    return this.wrapper.client.post(
      `data-pools/${this.wrapper.dataPoolId}/training-sets/${id}/reset-validation-rules/?advanced=true`
    );
  }

  certify(id: string) {
    return this.wrapper.client.post<ITrainingSet, ITrainingSet>(
      `data-pools/${this.wrapper.dataPoolId}/training-sets/${id}/certify/?advanced=true`
    );
  }

  revokeCertification(id: string) {
    return this.wrapper.client.post(
      `data-pools/${this.wrapper.dataPoolId}/training-sets/${id}/revoke-certification/?advanced=true`
    );
  }

  validate(id: string, documentId: string) {
    return this.wrapper.client.get<any, any>(
      `data-pools/${this.wrapper.dataPoolId}/training-sets/${id}/validate/?document=${documentId}`
    );
  }
}

export default TrainingSet;
